import ValueRule from '../ValueRule';

const MinimumValue = () => {
  return <ValueRule type='minimum_value' label='Minimum value' />;
};

export default MinimumValue;
